import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

export default forwardRef<SVGSVGElement, SvgIconProps>(function HelpIcon(props: SvgIconProps, ref) {
  return (
    <SvgIcon
      ref={ref}
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_20509_48436)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.2957 6.78447C11.752 6.68998 11.1924 6.79434 10.7192 7.07847C10.2422 7.36347 9.87471 7.81347 9.68871 8.35347C9.59124 8.63553 9.38572 8.86732 9.11735 8.99784C8.84899 9.12837 8.53976 9.14694 8.25771 9.04947C7.97565 8.95201 7.74386 8.74648 7.61334 8.47812C7.48281 8.20975 7.46424 7.90053 7.56171 7.61847C7.92021 6.58347 8.62671 5.70747 9.56421 5.14647C10.5005 4.58551 11.6074 4.38 12.6827 4.56747C13.7582 4.75632 14.7311 5.32279 15.4262 6.16497C16.123 7.0092 16.5029 8.07035 16.5002 9.16497C16.5002 9.89547 16.3622 10.5225 16.0877 11.064C15.8147 11.604 15.4412 11.994 15.0692 12.2895C14.7782 12.5235 14.4542 12.726 14.1977 12.8865L14.0537 12.9765C13.8092 13.1204 13.5817 13.2914 13.3757 13.4865C13.2521 13.6068 13.163 13.758 13.1177 13.9245C13.1027 14.2168 12.9744 14.4918 12.76 14.691C12.5457 14.8903 12.262 14.9981 11.9694 14.9917C11.6768 14.9852 11.3982 14.865 11.1928 14.6565C10.9874 14.448 10.8713 14.1677 10.8692 13.875C10.8692 13.6305 10.9217 13.389 10.9982 13.1565C11.1182 12.792 11.3462 12.342 11.7707 11.9085C12.1292 11.544 12.5282 11.28 12.8507 11.0775C12.9167 11.034 12.9797 10.9935 13.0397 10.9575C13.2932 10.7985 13.4837 10.6785 13.6622 10.5345C13.8357 10.4058 13.9787 10.2404 14.0807 10.05C14.1692 9.87447 14.2502 9.60597 14.2502 9.16497V9.16197C14.2518 8.59236 14.0544 8.04008 13.6922 7.60047C13.3322 7.16547 12.8372 6.87897 12.2957 6.78447Z'
          fill='currentColor'
        />
        <path
          d='M12 16.5C11.6022 16.5 11.2206 16.658 10.9393 16.9393C10.658 17.2206 10.5 17.6022 10.5 18C10.5 18.3978 10.658 18.7794 10.9393 19.0607C11.2206 19.342 11.6022 19.5 12 19.5H12.0105C12.4083 19.5 12.7899 19.342 13.0712 19.0607C13.3525 18.7794 13.5105 18.3978 13.5105 18C13.5105 17.6022 13.3525 17.2206 13.0712 16.9393C12.7899 16.658 12.4083 16.5 12.0105 16.5H12Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12ZM12 2.25C9.41414 2.25 6.93419 3.27723 5.10571 5.10571C3.27723 6.93419 2.25 9.41414 2.25 12C2.25 14.5859 3.27723 17.0658 5.10571 18.8943C6.93419 20.7228 9.41414 21.75 12 21.75C14.5859 21.75 17.0658 20.7228 18.8943 18.8943C20.7228 17.0658 21.75 14.5859 21.75 12C21.75 9.41414 20.7228 6.93419 18.8943 5.10571C17.0658 3.27723 14.5859 2.25 12 2.25Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_20509_48436'>
          <rect width='24' height='24' fill='transparent' />
        </clipPath>
      </defs>
    </SvgIcon>
  );
});
